import { View } from "@-/com.npmjs.react-native";
import { Icon } from "@-/dev.improve.haniverse.components.ui.icon";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { PREMIUM_BENEFITS } from "#premium-benefits";

/** Every {@link PREMIUM_BENEFITS} entry as an icon-bulleted list. */
export function PremiumBenefitList() {
  return (
    <View className="gap-3">
      {PREMIUM_BENEFITS.map((benefit) => (
        <View className="flex-row items-start gap-3" key={benefit.title}>
          <Icon className="mt-0.5 text-foreground" name={benefit.icon} size={18} />
          <View className="min-w-0 shrink gap-0.5">
            <Text className="font-sans text-[15px] font-medium" colorVariant="default">
              {benefit.title}
            </Text>
            <Text className="font-sans text-[13px]" colorVariant="muted">
              {benefit.description}
            </Text>
          </View>
        </View>
      ))}
    </View>
  );
}
